/**
 * Route for `linkedin-ads-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LinkedinAdsIntegrationPage } from "../features/linkedin-ads-integration/LinkedinAdsIntegrationPage";

export const linkedinAdsIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/linkedin-ads-integration",
	component: LinkedinAdsIntegrationPage,
});

export default linkedinAdsIntegrationRoute;
